import axios, { AxiosResponse } from "axios";
import { IQzuki, IQzukiJsonResponse, IQzukiListResponse, IPersonalResponse, IBadgesResponse, IAllBadges, IMyQzukiResponse, IAllMyQzuki, MateOccupations, UserLastQzukiHero } from "../bean/ResponseBean";
import { MythServerResultCode } from "../constant/CommonConstant";
import { handleMythServerError } from "./ApiErrorHandler";
import { IFilterTraits } from "../bean/RequestBean";
import { delayAsync } from "../utils/commonUtils";
import { handleTokenInvalid } from "./TokenHandler";
import { getLocalStorageTokenKey } from "../stores/web3Store";
import { appEnv } from "../env";

//must Cancellation , otherwise Pinta has CROS
//to fix CROS for myth server
//axios.defaults.withCredentials = true;

function tokenHeaderConfig(account: string, contentType = ContentType.FORM) {
    const token = localStorage.getItem(getLocalStorageTokenKey(account));

    return {
        headers: {
            //"token": "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIxIiwiaWF0IjoxNjgyNjY5ODQyLCJleHAiOjE2ODI3NTYyNDIsIndhbGxldEFkZHJlc3MiOiIweDVlYzc0NTE4NmJlMzk4MjJlNTQyODk3NzRiYmEzYTcyOWE4MTExZjgifQ.hiZkZP0r3KDemy3hPVrMx3LgpRYN8tidqQ6ZjQkVtdU",
            "token": token!,
            "content-type": contentType,
        }
    }
}

export const ContentType = {
    JSON: "application/json;charset=UTF-8",
    FORM: "application/x-www-form-urlencoded;charset=utf-8"
};

/**
 * response拦截器，处理以下情况:
 * 1.处理业务错误
 * 2.token失效
 */
axios.interceptors.response.use(
    res => {
        // if (res.data.resultCode && res.data.resultCode !== MythServerResultCode.SUCCESS) {
        //     handleMythServerError(res.data.resultMessage);
        // }
        return res
    }, err => {
        //catch error  
        if (err.response && err.response.status === 403
            && err.response.data && err.response.data.resultCode === 501) {
            handleTokenInvalid();
        } else if (err.response && err.response.status === 400) {
            handleMythServerError(err.response.data.resultMessage);
        }
        return err
    }
);

export interface IGetListParams {
    filterGoldenMode?: boolean,
    tokenId?: string,
    random: boolean
    filterTraits?: IFilterTraits[],
    pageNum: number,
    pageSize: number,
    firstItemTokenId?: string
}

export default class MythServerApi {
    private _qzukis: IQzuki[] = [];

    private async fetchGalleryData(random: boolean, firstItemTokenId?: string): Promise<IQzuki[]> {
        if (!this._qzukis || this._qzukis.length === 0) {
            const url = "https://qzuki.myth.art/metadata/gallery.json";
            const response: AxiosResponse<IQzukiJsonResponse> = await axios.get<IQzukiJsonResponse, AxiosResponse<IQzukiJsonResponse>>(url);
            this._qzukis = response.data.data;
        }

        if (random) {
            this._qzukis = this._qzukis.sort((a, b) => {
                //put this item at first
                if (firstItemTokenId) {
                    if (a.name.endsWith("#" + firstItemTokenId)) {
                        return -1;
                    }
                    if (b.name.endsWith("#" + firstItemTokenId)) {
                        return 1;
                    }
                }
                return Math.random() - 0.5
            })

        }
        return this._qzukis;
    }

    public async getList(params: IGetListParams): Promise<IQzukiListResponse> {
        const qzukis = await this.fetchGalleryData(params.random, params.firstItemTokenId);

        // await delayAsync(3000);
        if (qzukis && qzukis.length > 0) {
            const filterResult: IQzuki[] = qzukis.filter(item =>
                this.filterByTraits(params, item)
            );

            const start = (params.pageNum - 1) * params.pageSize;
            if (filterResult && filterResult.length > start) {
                let end = params.pageNum * params.pageSize;
                end = end > filterResult.length ? filterResult.length : end;
                const result = filterResult.slice(start, end);
                return { data: result, total: filterResult.length };
            }
        }


        return { data: [], total: 0 };
    }

    public async getSingleQzuki(tokenId: number): Promise<IQzuki | undefined> {
        const qzukis = await this.fetchGalleryData(false);

        if (qzukis && qzukis.length > 0) {
            return qzukis[tokenId];
        }

        return undefined;
    }

    public async getAllTraits(): Promise<Map<string, Map<string, number>>> {
        const qzukis = await this.fetchGalleryData(false);
        let map = new Map();
        qzukis.forEach(item => {
            for (let attributesKey in item.attributes) {
                const value = (item.attributes as any)[attributesKey];
                const innerMap: Map<string, number> = map.get(attributesKey);
                if (innerMap) {
                    const innerValue = innerMap.get(value);
                    if (innerValue) {
                        innerMap.set(value, innerValue + 1);
                    } else {
                        innerMap.set(value, 1);
                    }
                } else {
                    const newMap = new Map();
                    newMap.set(value, 1);
                    map.set(attributesKey, newMap);
                }
            }
        });

        // await delayAsync(10000);
        return map;
    }

    private filterByTraits(params: IGetListParams, item: IQzuki) {
        let filterGoldenModeFlag = true;
        let tokenIdFlag = true;
        let filterTraitsFlag = true;
        if (params.filterGoldenMode) {
            let tempFlag = false;
            for (let attributesKey in item.attributes) {
                if (item.attributes[attributesKey].startsWith("Golden")) {
                    tempFlag = true;
                    break;
                }
            }
            filterGoldenModeFlag = tempFlag;
        }
        if (params.tokenId) {
            tokenIdFlag = item.name.endsWith("#" + params.tokenId);
        }
        if (params.filterTraits) {
            filterTraitsFlag = params.filterTraits.findIndex(traitFilter => {
                let traitValue = (item.attributes as any)[traitFilter.key];
                return !traitValue || !traitFilter.values.includes(traitValue);
            }) === -1;
        }

        return filterGoldenModeFlag && tokenIdFlag && filterTraitsFlag;
    }


    public async requestLogin(wallet: string, signature: string) {
        const url = appEnv.qzukiServerApis.login.requestLogin
        const formData = new FormData();
        formData.append("wallet ", wallet);
        formData.append("signature ", signature);
        const response = await axios.put(url, formData)

        return response.data
    }

    //获取nonce
    public async getNonce(wallet: string) {
        const url = appEnv.qzukiServerApis.login.getNonce + `?wallet=${wallet}`
        const response = await axios.get(url);

        return response.data
    }

    //获取个人中心页所有信息
    public async getPersonalInfo(wallet: string): Promise<IPersonalResponse> {
        const url = appEnv.qzukiServerApis.personal.getPersonalInfo + `?wallet=${wallet}`
        const response: AxiosResponse<IPersonalResponse> = await axios.get<IPersonalResponse, AxiosResponse<IPersonalResponse>>(url);

        return response.data
    }

    //获取所有badges
    public async getAllBadges(): Promise<IAllBadges[]> {
        const url = appEnv.qzukiServerApis.personal.getAllBadges
        const response: AxiosResponse<IBadgesResponse> = await axios.get<IBadgesResponse, AxiosResponse<IBadgesResponse>>(url);
        return response.data.badges
    }

    //获取个人账号所有的Qzuki
    public async getAllMyQzukis(wallet: string): Promise<IAllMyQzuki[]> {
        const url = appEnv.qzukiServerApis.personal.getAllMyQzukis + `?wallet=${wallet}`
        //const url = appEnv.qzukiServerApis.personal.getAllMyQzukis + '?wallet=0x5ec745186be39822e54289774bba3a729a8111f8'
        const response: AxiosResponse<IMyQzukiResponse> = await axios.get<IMyQzukiResponse, AxiosResponse<IMyQzukiResponse>>(url);
        return response.data.qzukis
    }

    public async getOwner(tokenId: number): Promise<string> {
        let allMyQzukis: IAllMyQzuki[] = []
        const url = appEnv.qzukiServerApis.common.getOwner + `?tokenId=${tokenId}`
        const response: AxiosResponse<string> = await axios.get<string, AxiosResponse<string>>(url);

        return response.data;
    }

    public async updateDisplayBanner(bannerTokenId: number, account: string) {
        const url = appEnv.qzukiServerApis.personal.updateDisplayBanner
        const formData = new FormData();
        formData.append("bannerTokenId", bannerTokenId.toString());
        const result = await axios.put(url, formData, tokenHeaderConfig(account))
        return this.handlePutResult(result);
    }

    public async updateDisplayQzukis(qzukiTokenIds: number[], account: string) {
        const url = appEnv.qzukiServerApis.personal.updateDisplayQzukis
        const formData = new FormData();
        formData.append("qzukiTokenIds", qzukiTokenIds.toString());
        const result = await axios.put(url, formData, tokenHeaderConfig(account))
        return this.handlePutResult(result);
    }

    public async updateUserName(userName: string, account: string): Promise<boolean> {
        const url = appEnv.qzukiServerApis.personal.updateUserName
        const formData = new FormData();
        formData.append("userName", userName.toString());
        const result = await axios.put(url, formData, tokenHeaderConfig(account))
        return this.handlePutResult(result);
    }

    //增加修改次数
    public async addSubmitCounts(qzukiId: number, account: string) {
        const url = appEnv.qzukiServerApis.hero.addSubmitCounts + `?qzukiId=${qzukiId}`
        // const url = 'http://localhost:8080/api/hero/add-chatGpt-times?qzukiId=' + qzukiId
        const result = await axios.get(url, tokenHeaderConfig(account))
        return result.status;
    }

    //获取修改次数
    public async getSubmitCounts(qzukiId: number, account: string) {
        const url = appEnv.qzukiServerApis.hero.getSubmitCounts + `?qzukiId=${qzukiId}`
        //const url = 'http://localhost:8080/api/hero/get-chatGpt-times?qzukiId=' + qzukiId
        const result = await axios.get(url, tokenHeaderConfig(account))
        return result.data;
    }

    //获取职业
    public async getMateOccupations(qzukiId: number, account: string): Promise<MateOccupations> {
        const url = appEnv.qzukiServerApis.hero.getMateOccupations + `?qzukiId=${qzukiId}`
        //const url = 'http://localhost:8080/api/hero/mate-occupations?qzukiId=' + qzukiId
        const result: AxiosResponse<MateOccupations> = await axios.get<MateOccupations, AxiosResponse<MateOccupations>>(url, tokenHeaderConfig(account))
        return result.data;
    }

    //提交故事
    public async submitHeroStory(qzukiId: number, account: string, heroStory: string, name: string, occupationId: number, selectedPersonalitys: string[]): Promise<boolean> {
        const url = appEnv.qzukiServerApis.hero.submitHeroStory
        //const url = 'http://localhost:8080/api/hero/submit-hero-story'
        const formData = new FormData();
        const Personality: any = {}
        selectedPersonalitys.forEach((item, key) => {
            Personality[item] = item
        })

        formData.append("qzukiId", qzukiId.toString());
        formData.append("heroName", name);
        formData.append("heroPersonality", JSON.stringify(Personality));
        formData.append("heroStory", heroStory);
        formData.append("occupationId", occupationId.toString());
        const result = await axios.put(url, formData, tokenHeaderConfig(account))

        return result.status === 200 ? true : false;
    }

    //获取全部故事
    public async getUserLastHeros(account: string) {
        const url = appEnv.qzukiServerApis.hero.getUserLastHeros + `?wallet=${account}`
        //const url = 'http://localhost:8080/api/hero/user-last-heros'
        const result = await axios.get(url, tokenHeaderConfig(account))
        return result.data;
    }

    //获取指定故事
    public async getUserLastQzukiHero(qzukiId: number, account: string): Promise<UserLastQzukiHero> {
        const url = appEnv.qzukiServerApis.hero.getUserLastQzukiHero + `?qzukiId=${qzukiId}&wallet=${account}`
        //const url = 'http://localhost:8080/api/hero/user-last-qzuki-hero?qzukiId=' + qzukiId
        const result: AxiosResponse<UserLastQzukiHero> = await axios.get<UserLastQzukiHero, AxiosResponse<UserLastQzukiHero>>(url)
        return result.data;
    }

    public async chatGPT(account: string, qzukiId: number, name: string, occupationName: string, selectedPersonalitys: string[], language: string, careerIntroduction: string) {
        const url = 'https://api.openai.com/v1/chat/completions'
        let comeFrom = ''

        if (language === '中文') {
            comeFrom = "故事出自chatgpt"
        } else {
            comeFrom = "the story is from chatgpt"
        }

        const result = await axios.post(url,
            {
                "model": "gpt-3.5-turbo",
                "messages": [{
                    "role": "user",
                    "content": '你好，我想生成一个故事。接下来，我会依次给你提供故事的背景，故事的主线以及故事的设定。然后，我需要你帮我在这个基础上，结合我给你的一些人物信息，帮我生成他们各自的人物故事，谢谢。与此同时，请在人物故事结尾，加一句话：' + comeFrom + '.以下是故事背景：数万年以前，Zuki大陆出现了一座高耸入云的黑色方碑。当方碑出现后，周围的森林、生物迅速凋零和死亡，强大的湮灭能量不断向四周辐射，形成了无法靠近的死域。这些方碑被称作湮灭方碑。灵能者们前往调查，却发现湮灭方碑周围存在力场，当靠近方碑时，体内的灵能会逐渐消失。当有人尝试触摸方碑时，他们原本消失的能量则会立刻爆发，这些灵能者的皮肤开始变红，意识变得疯狂，紊乱的灵能会让他们如气球一般炸开。少数意志坚强的灵能者最终活了下来，并且觉醒了全新的湮灭能量，但由于他们的思维已经疯狂化，并且必须依靠湮灭石碑提供的能量维持清醒，他们往往会选择加入暗影军团，这类红色皮肤的灵能者被称为湮灭者。最终，在尝试了无数种办法后，高等级灵能者们终于摧毁了一座湮灭方碑后。他们却意外地发现方碑有能量提纯的功能，散落在外的湮灭碎片可以提升灵能者的力量。有贪婪的灵能者立刻融合了大量湮灭碎片，没想到却逐渐失去意识，堕落成了疯狂的怪物。与此同时，Zuki大陆各地开始不断出现湮灭方碑，伴随方碑出现的还有一种类人型的怪物，它们的鼻子凹陷，牙齿尖锐，只有四肢手指，使用湮灭能量作战，他们最大的特点是可以融入影子，甚至将对手拉入影子中，因此他们被称作暗影军团。大量湮灭方碑的出现让zuki大陆的生存环境日益恶化，灵能者们开始摧毁湮灭方碑。为了解决靠近方碑就会失去灵能力的问题，灵能研究院研发了一种灵能固化技术。把巨量的灵能力压缩至一个灵能者的体内，极致的灵能力会升维成小型领域，在领域内作战时，能大幅抵消掉湮灭方碑的力场。由于吸收了远超自身等级的灵能力，这些灵能者的皮肤会变成蓝色，他们也被称作守护者。湮灭方碑周围不仅有疯狂的湮灭者，守护着方碑的暗影军团，还有在湮灭能量下侥幸存活的野兽，这些野兽因为吸收了少量的湮灭能量，变异成了嗜血的魔兽。除了灵能力和湮灭之力外，这个世界上还有一种力量被称作圣力，拥有这种力量的灵能者能将圣力附在武器上，使武器变成金色。如果说灵能力是基础能力的话，那湮灭能量和圣力都是属于高维能力。将圣力包裹在身体外层时，同样也能抵抗湮灭方碑的弱化力场。拥有圣力的灵能者被称为圣者。当灵能力提升至极致，并且掌握了等量的湮灭能力后，因为两种力量的对冲导致灵能者的身体被彻底摧毁，但与之而来的是一种稳定的灵魂形态，这种形态的灵能者被称为灵魂行者。灵魂行者不会受到湮灭方碑的影响，也不会走向疯狂。每一个灵魂行者都具有强大、无可比拟的战斗力，他们对世界的走向有着重要的作用。灵能力是一种自由的能量状态，没有任何属性。但一些灵能者天生与元素亲和，因此能将灵能力变化成水、火、大地、雷电四种元素之力。元素之力是一种稳固的能量结构，其攻击能力甚至超过圣力，但缺点是元素之力无法仍然属于灵能力的范畴，无法抵消更高位的湮灭方碑力场。掌握了元素之力的灵能者被称为元素掌控者。灵能者与暗影军团的战斗持续了数万年。在这期间zuki大陆形成了多个阵营。所有灵能者都可以根据自己的喜好加入不同的阵营和组织。请结合上面的故事背景创造属于编号#' + qzukiId + '的角色故事, 名称：' + name + ',性格:' + selectedPersonalitys + ',职业:' + occupationName + ',职业介绍:' + careerIntroduction + ',职业介绍仅作参考,可以不按照职业介绍来创作故事。用' + language + '翻译创作好的故事,并返回创作好的故事。'
                }]
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer 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"
                }
            })

        if (result.status === 200) {
            this.addSubmitCounts(qzukiId, account)
        }

        return result.data;
    }

    public handlePutResult(result: AxiosResponse): boolean {
        return result.status === 200;
    }
}
